window.addEventListener('message', (event) => {
	if (event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormSubmit') {
		console.log('Hubspot form submission detected', event);

		gptwGA.event('Form', 'Submit', event.data.id);
	}
});
